import React from 'react';
import PopupModal from 'components/PopupModal/PopupModal';
import modalTypes from 'utils/modalTypesEnum';

interface Props {
  onKeepAnnual: () => void;
  onGoMonthly: () => void;
  onDismiss: () => void;
}

// Shown when European Rescue and Monthly Flex would otherwise both be active; onDismiss leaves things unchanged.
const EuropeanRescueMonthlyFlexModal = ({ onKeepAnnual, onGoMonthly, onDismiss }: Props) => (
  <PopupModal
    modalType={modalTypes.confirmationModal}
    displayDialogInMiddle
    innerCloseButton
    action={onDismiss}
    resultTitle={<span>Sorry, European Rescue can&apos;t be added when purchasing monthly</span>}
    resultText={(
      <div>
        <p className="text-center text-muted">Please choose an option below to continue</p>
        <button
          type="button"
          className="btn w-100 border rounded-3 d-flex align-items-center p-3 mb-2 text-start"
          onClick={onKeepAnnual}
        >
          <i className="fas fa-check-circle text-success fs-2 me-3" />
          <span className="fw-bold">Keep European Rescue and pay annually</span>
        </button>
        <button
          type="button"
          className="btn w-100 border rounded-3 d-flex align-items-center p-3 text-start"
          onClick={onGoMonthly}
        >
          <i className="fas fa-times-circle text-danger fs-2 me-3" />
          <span className="fw-bold">Remove European Rescue and pay monthly</span>
        </button>
      </div>
    )}
  />
);

export default EuropeanRescueMonthlyFlexModal;
